import React, {
  useCallback,
} from 'react';
import {
  APP_ROUTES,
} from 'views/EMR/router';
import {
  useAuth,
} from 'core/hooks';
import GoogleIcon from 'core/icons/google';
import Button from 'pages/Dashboard/components/Button';

export default function LoginSection() {
  const {
    loginWithRedirect,
  } = useAuth();

  const handleGoogleLogin = useCallback(() => {
    loginWithRedirect({
      authorizationParams: {
        connection: 'google-oauth2',
      },
      appState: {
        targetUrl: APP_ROUTES.POPULATE_SUPPORT.PORTAL,
      },
    });
  }, [loginWithRedirect]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md border border-slate-200">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-semibold text-slate-800">
            Support Portal
          </h1>
          <p className="text-slate-500 mt-2 text-sm">
            Sign in with your Populate account
          </p>
        </div>
        <Button
          variant="outlined"
          onClick={handleGoogleLogin}
          className="!max-w-[initial] !w-full flex items-center justify-center gap-3  !rounded-lg !px-6 !py-3 !text-sm font-medium text-gray-800 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
        >
          <GoogleIcon className="!w-5 !h-5" />
          Sign in with Google
        </Button>
      </div>
    </div>
  );
}
